import { render, staticRenderFns } from "./Vehicle.vue?vue&type=template&id=74cb2ff6"
import script from "./Vehicle.vue?vue&type=script&lang=js"
export * from "./Vehicle.vue?vue&type=script&lang=js"
import style0 from "./Vehicle.vue?vue&type=style&index=0&id=74cb2ff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports